import { NgComponentOutlet } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChangeDetectionStrategy, Component, DestroyRef, HostListener, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ContentViewStore } from 'app/state-management/content-view/content-view.store';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'sma-web-right-content-view-overlay',
  imports: [NgComponentOutlet, TranslateModule],
  templateUrl: 'right-content-view-overlay.component.html',
  styleUrl: 'right-content-view-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RightContentViewOverlayComponent {
  protected readonly contentViewStore: ContentViewStore = inject(ContentViewStore);
  private readonly router: Router = inject(Router);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        if (this.contentViewStore.isOpen()) {
          this.contentViewStore.close();
        }
      });
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.contentViewStore.isOpen()) {
      this.contentViewStore.close();
    }
  }

  close(): void {
    this.contentViewStore.close();
  }
}
